//rokid 增加去头去尾的纯workspace菜单，copyFrom  workspace-sub-menu

import { useEffect, type ReactNode } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { Space, Skeleton } from '@coze-arch/coze-design';
import { useSpaceStore } from '@coze-foundation/space-store';
import { type IWorkspaceListItem } from './components/workspace-list-item';
import { WorkspaceList } from './components/workspace-list';
import { useRouteConfig } from '@coze-arch/bot-hooks';
import { I18n } from '@coze-arch/i18n';
import { SpaceSubModuleEnum } from '@coze-foundation/space-ui-adapter';
import {
  IconCozBot,
  IconCozBotFill,
  IconCozKnowledge,
  IconCozKnowledgeFill,
  IconCozModel,
  IconCozModelFill,
  IconCozTemplate,
  IconCozTemplateFill,
  IconCozPlugin,
  IconCozPluginFill,
  IconCozHouse,
  IconCozHouseFill,
} from '@coze-arch/coze-design/icons';
import './components/list.css';

export const WorkspaceSubMenuNew = () => {
  let { subMenuKey, menuKey, type, requireAuth, hasSider } = useRouteConfig();
  //rokid 二级菜单提级以后，通过这种方式强制拼接非 workspace二级菜单外的subMenukey
  if (!subMenuKey && hasSider) {
    subMenuKey = `/${menuKey}/${type}`;
  }
  const subMenu = [
    {
      icon: <IconCozHouse />,
      activeIcon: <IconCozHouseFill />,
      title: () => '首页',
      path: 'HOME',
      dataTestId: 'navigation_workspace_home',
      module: 'workspace',
    },
    {
      icon: <IconCozBot />,
      activeIcon: <IconCozBotFill />,
      title: () => I18n.t('navigation_workspace_develop', {}, 'Develop'),
      path: SpaceSubModuleEnum.DEVELOP,
      dataTestId: 'navigation_workspace_develop',
      module: 'workspace',
    },
    {
      icon: <IconCozKnowledge />,
      activeIcon: <IconCozKnowledgeFill />,
      title: () => I18n.t('navigation_workspace_library', {}, 'Library'),
      path: SpaceSubModuleEnum.LIBRARY,
      dataTestId: 'navigation_workspace_library',
      module: 'workspace',
    },
    // rokid 添加rokid模型
    {
      icon: <IconCozModel />,
      activeIcon: <IconCozModelFill />,
      title: () => '模型',
      path: SpaceSubModuleEnum.ROKIDMODEL,
      dataTestId: 'navigation_workspace_rokidmodel',
      module: 'workspace',
    },

    {
      type: 'plugin',
      icon: <IconCozPlugin />,
      activeIcon: <IconCozPluginFill />,
      title: () => I18n.t('Plugins'),
      isActive: true,
      path: '/explore/plugin',
      module: 'explore',
    },
    {
      icon: <IconCozTemplate />,
      activeIcon: <IconCozTemplateFill />,
      title: () => I18n.t('template_name'),
      isActive: true,
      type: 'template',
      path: '/explore/template',
      module: 'explore',
    },
  ];

  const {
    spaceList,
    loading,
    currentSpace,
    fetchSpaces,
    setSpace,
    resetProps,
  } = useSpaceStore(
    useShallow(state => ({
      currentSpace: state.space,
      spaceList: state.spaceList,
      loading: !!state.loading || !state.inited,
      fetchSpaces: state.fetchSpaces,
      setSpace: state.setSpace,
      resetProps: state.resetProps,
    }))
  );
  //rokid 二级菜单提级以后，通过这种方式强制查询spaces列表
  useEffect(() => {
    if (spaceList.length) {
      setSpace(spaceList[0].id);
      resetProps({ loading: false });
    } else {
      if (!currentSpace) {
        fetchSpaces(true);
      }
    }
  }, [currentSpace]);
  return <WorkspaceList menus={subMenu} currentSubMenu={subMenuKey} />;
  // return (
  //   <Skeleton loading={loading} active placeholder={<Skeleton.Paragraph />}>
  //     <WorkspaceList menus={subMenu} currentSubMenu={subMenuKey} />
  //   </Skeleton>
  // );
};

export { IWorkspaceListItem };
